<template>
  <div class="home">
     <v-layout wrap class="colorGuide">
        <v-flex xs12>
            <v-chip small style="font-size: small"><v-icon color=green>mdi-square</v-icon> Ok</v-chip>
            <v-chip small style="font-size: small"><v-icon color=red>mdi-square</v-icon> -  8 hs</v-chip>
            <v-chip small style="font-size: small"><v-icon color=orange>mdi-square</v-icon> + 8 hs</v-chip>
            <v-chip small style="font-size: small"><v-icon color=blue>mdi-square</v-icon> Extra</v-chip>
            <v-chip small style="font-size: small"><v-icon color=purple>mdi-square</v-icon> Retén</v-chip>
            <v-chip small style="font-size: small"><v-icon color=#000080>mdi-square</v-icon> Cursos</v-chip>
        </v-flex>
     </v-layout>
    <CalendarSummary/>
  </div>
</template>

<script>
// @ is an alias to /src

import CalendarSummary from '@/components/CalendarSummary.vue'

export default {
  name: 'CalendarViewSummary',
  components: {
    //HelloWorld,
    CalendarSummary    
  }
}
</script>
<style scoped>
.home{
  height: 100%;
}
.fc{
  height: 100%;
}
.colorGuide{
  position: absolute;
  z-index: 1;
  font-size: xx-small !important;
  bottom: 0px;
}

</style>
